/**
 * Amber bar on the private photo list only.
 */

import { Link } from 'react-router-dom';
import { PREVIEW_PHOTOS_PATH } from '../../pages/preview/previewPhotoShots';

export default function PreviewBanner() {
  return (
    <div
      className="border-b border-amber-300 bg-amber-100 px-4 py-2 text-center text-sm text-amber-950"
      data-testid="preview-banner"
    >
      Photo list — not indexed.{' '}
      <Link to="/" className="font-semibold underline underline-offset-2 hover:text-amber-800">
        Open the homepage
      </Link>
      {' · '}
      <Link to={PREVIEW_PHOTOS_PATH} className="font-semibold underline underline-offset-2 hover:text-amber-800">
        Photos to take
      </Link>
    </div>
  );
}
